import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }]
  },
  {
    path: '/company',
    component: Layout,
    redirect: '/company/companyManage',
    name: 'company',
    meta: {
      title: '企业管理',
      icon: 'company'
    },
    children: [{
      path: 'companyManage',
      name: 'companyManage',
      component: () => import('@/views/company/companyManage/index'),
      meta: {
        title: '企业信息',
        icon: 'company-list'
      }
    },
      {
        path: 'companyDetail',
        name: 'companyDetail',
        component: () => import('@/views/company/companyManage/detail'),
        meta: {
          title: '企业详情'
        },
        hidden: true
      },
      {
        path: 'addCompany',
        name: 'addCompany',
        component: () => import('@/views/company/companyManage/add'),
        meta: {
          title: '添加企业'
        },
        hidden: true
      },
      {
        path: 'updateCompany',
        name: 'updateCompany',
        component: () => import('@/views/company/companyManage/update'),
        meta: {
          title: '编辑企业'
        },
        hidden: true
      },
      {
        path: 'deleteCompany',
        name: 'deleteCompany',
        component: () => import('@/views/pms/product/index'),
        meta: {
          title: '删除企业'
        },
        hidden: true
      },
      {
        path: 'dealerManage',
        name: 'dealerManage',
        component: () => import('@/views/company/dealerManage/index'),
        meta: {
          title: '经销商管理',
          icon: 'dealer-list'
        }
      },
      {
        path: 'dealerDetail',
        name: 'dealerDetail',
        component: () => import('@/views/company/dealerManage/detail'),
        meta: {
          title: '经销商详情'
        },
        hidden: true
      },
      {
        path: 'addDealer',
        name: 'addDealer',
        component: () => import('@/views/company/dealerManage/add'),
        meta: {
          title: '添加经销商'
        },
        hidden: true
      },
      {
        path: 'updateDealer',
        name: 'updateDealer',
        component: () => import('@/views/company/dealerManage/update'),
        meta: {
          title: '编辑经销商'
        },
        hidden: true
      },
      {
        path: 'deleteDealer',
        name: 'deleteDealer',
        component: () => import('@/views/company/dealerManage/index'),
        meta: {
          title: '删除经销商'
        },
        hidden: true
      },
      {
        path: 'importDealer',
        name: 'importDealer',
        component: () => import('@/views/company/dealerManage/index'),
        meta: {
          title: '导入经销商'
        },
        hidden: true
      },
      {
        path: 'dealerLevelManage',
        name: 'dealerLevelManage',
        component: () => import('@/views/company/dealerLevelManage/index'),
        meta: {
          title: '经销商等级管理',
          icon: 'dealerLevel-list'
        },
        hidden: true
      },
      {
        path: 'dealerLevelDetail',
        name: 'dealerLevelDetail',
        component: () => import('@/views/company/dealerLevelManage/detail'),
        meta: {
          title: '经销商等级详情'
        },
        hidden: true
      },
      {
        path: 'addDealerLevel',
        name: 'addDealerLevel',
        component: () => import('@/views/company/dealerLevelManage/add'),
        meta: {
          title: '添加经销商等级'
        },
        hidden: true
      },
      {
        path: 'updateDealerLevel',
        name: 'updateDealerLevel',
        component: () => import('@/views/company/dealerLevelManage/update'),
        meta: {
          title: '编辑经销商等级',
          icon: 'dealerLevel-update'
        },
        hidden: true
      },
      {
        path: 'deleteDealerLevel',
        name: 'deleteDealerLevel',
        component: () => import('@/views/company/dealerLevelManage/index'),
        meta: {
          title: '删除经销商等级'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/productManage',
    name: 'product',
    meta: {
      title: '产品管理',
      icon: 'product'
    },
    children: [{
      path: 'productManage',
      name: 'productManage',
      component: () => import('@/views/product/productManage/index'),
      meta: {
        title: '产品列表',
        icon: 'product-list'
      }
    },
      {
        path: 'productDetail',
        name: 'productDetail',
        component: () => import('@/views/product/productManage/detail'),
        meta: {
          title: '产品详情'
        },
        hidden: true
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/product/productManage/add'),
        meta: {
          title: '添加产品'
        },
        hidden: true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/product/productManage/update'),
        meta: {
          title: '编辑产品'
        }
      },
      {
        path: 'deleteProduct',
        name: 'deleteProduct',
        component: () => import('@/views/oms/apply/index'),
        meta: {
          title: '删除产品'
        }
      },
      {
        path: 'productCategory',
        name: 'productCategory',
        component: () => import('@/views/product/productCategory/index'),
        meta: {
          title: '产品分类列表',
          icon: 'product-category'
        }
      },
      {
        path: 'addProductCategory',
        name: 'addProductCategory',
        component: () => import('@/views/product/productCategory/add'),
        meta: {
          title: '添加产品分类'
        },
        hidden: true
      },
      {
        path: 'productCategoryDetail',
        name: 'productCategoryDetail',
        component: () => import('@/views/product/productCategory/detail'),
        meta: {
          title: '产品分类详情'
        },
        hidden: true
      },
      {
        path: 'updateProductCategory',
        name: 'updateProductCategory',
        component: () => import('@/views/product/productCategory/update'),
        meta: {
          title: '修改产品分类'
        }
      },
      {
        path: 'deleteProductCategory',
        name: 'deleteProductCategory',
        component: () => import('@/views/oms/apply/index'),
        meta: {
          title: '删除产品分类'
        }
      }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/activityManage',
    name: 'activity',
    meta: {
      title: '活动管理',
      icon: 'activity'
    },
    children: [{
      path: 'activityManage',
      name: 'activityManage',
      component: () => import('@/views/activity/activityManage/index'),
      meta: {
        title: '活动列表',
        icon: 'activity-list'
      }
    },
      {
        path: 'addActivity',
        name: 'addActivity',
        component: () => import('@/views/activity/activityManage/add'),
        meta: {
          title: '添加活动'
        },
        hidden: true
      },
      {
        path: 'activityDetail',
        name: 'activityDetail',
        component: () => import('@/views/activity/activityManage/detail'),
        meta: {
          title: '活动详情'
        },
        hidden: true
      },
      {
        path: 'updateActivity',
        name: 'updateActivity',
        component: () => import('@/views/activity/activityManage/update'),
        meta: {
          title: '编辑活动'
        },
        hidden: true
      },
      {
        path: 'deleteActivity',
        name: 'deleteActivity',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {
          title: '删除活动'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/delivery',
    component: Layout,
    redirect: '/delivery/deliveryManage',
    name: 'delivery',
    meta: {
      title: '发货管理',
      icon: 'home'
    },
    children: [{
      path: 'deliveryManage',
      name: 'deliveryManage',
      component: () => import('@/views/delivery/deliveryManage/index'),
      meta: {
        title: '发货单列表',
        icon: 'delivery-list'
      }
    },
      {
        path: 'deliveryDetail',
        name: 'deliveryDetail',
        component: () => import('@/views/delivery/deliveryManage/detail'),
        meta: {
          title: '发货单详情'
        },
        hidden: true
      },
      {
        path: 'addDelivery',
        name: 'addDelivery',
        component: () => import('@/views/delivery/deliveryManage/add'),
        meta: {
          title: '添加发货单'
        },
        hidden: true
      },
      {
        path: 'updateDelivery',
        name: 'updateDelivery',
        component: () => import('@/views/delivery/deliveryManage/update'),
        meta: {
          title: '修改发货单'
        },
        hidden: true
      },

      {
        path: 'importDelivery',
        name: 'importDelivery',
        component: () => import('@/views/ums/member/update'),
        meta: {
          title: '导入发货单'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/return',
    component: Layout,
    redirect: '/return/returnManage',
    name: 'return',
    meta: {
      title: '退货管理',
      icon: 'home'
    },
    children: [{
      path: 'returnManage',
      name: 'returnManage',
      component: () => import('@/views/return/returnManage/index'),
      meta: {
        title: '退货列表',
        icon: 'product-list'
      }
    },
      {
        path: 'returnDetail',
        name: 'returnDetail',
        component: () => import('@/views/return/returnManage/detail'),
        meta: {
          title: '退货详情'
        },
        hidden: true
      },
      {
        path: 'addReturn',
        name: 'addReturn',
        component: () => import('@/views/return/returnManage/add'),
        meta: {
          title: '添加退货单'
        },
        hidden: true
      },
      {
        path: 'updateReturn',
        name: 'updateReturn',
        component: () => import('@/views/sys/admin/update'),
        meta: {
          title: '编辑退货单'
        },
        hidden: true
      },
      {
        path: 'deleteReturn',
        name: 'deleteReturn',
        component: () => import('@/views/sys/admin/update'),
        meta: {
          title: '删除退货单'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/stock',
    component: Layout,
    redirect: '/stock/productStockManage',
    name: 'stock',
    meta: {
      title: '库存管理',
      icon: 'home'
    },
    children: [{
      path: 'productStockManage',
      name: 'productStockManage',
      component: () => import('@/views/productStock/productStockManage/index'),
      meta: {
        title: '产品库存列表',
        icon: 'product-list'
      }
    },
      {
        path: 'productStockDetail',
        name: 'productStockDetail',
        component: () => import('@/views/cms/subject/index'),
        meta: {
          title: '产品库存详情'
        },
        hidden: true
      },
      {
        path: 'inboundManage',
        name: 'inboundManage',
        component: () => import('@/views/productStock/inboundManage/index'),
        meta: {
          title: '入库列表',
          icon: 'product-list'
        }
      },
      {
        path: 'inboundDetail',
        name: 'inboundDetail',
        component: () => import('@/views/productStock/inboundManage/detail'),
        meta: {
          title: '入库单详情'
        },
        hidden: true
      },
      {
        path: 'addInbound',
        name: 'addInbound',
        component: () => import('@/views/cms/subject/add'),
        meta: {
          title: '添加入库单'
        },
        hidden: true
      },
      {
        path: 'updateInbound',
        name: 'updateInbound',
        component: () => import('@/views/cms/subject/update'),
        meta: {
          title: '编辑入库单'
        },
        hidden: true
      },
      {
        path: 'deleteInbound',
        name: 'deleteInbound',
        component: () => import('@/views/cms/subject/update'),
        meta: {
          title: '删除入库单'
        },
        hidden: true
      },
      {
        path: 'outboundManage',
        name: 'outboundManage',
        component: () => import('@/views/productStock/outboundManage/index'),
        meta: {
          title: '出库列表',
          icon: 'product-list'
        }
      },
      {
        path: 'outboundDetail',
        name: 'outboundDetail',
        component: () => import('@/views/productStock/outboundManage/detail'),
        meta: {
          title: '出库单详情'
        },
        hidden: true
      },
      {
        path: 'addOutbound',
        name: 'addOutbound',
        component: () => import('@/views/cms/helpCategory/add'),
        meta: {
          title: '添加出库单'
        },
        hidden: true
      },
      {
        path: 'updateOutbound',
        name: 'updateOutbound',
        component: () => import('@/views/cms/helpCategory/update'),
        meta: {
          title: '编辑出库单'
        },
        hidden: true
      },
      {
        path: 'deleteOutbound',
        name: 'deleteOutbound',
        component: () => import('@/views/cms/helpCategory/update'),
        meta: {
          title: '删除出库单'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/qrcode',
    component: Layout,
    redirect: '/qrcode/qrcodeApplyManage',
    name: 'qrcode',
    meta: {
      title: '二维码管理',
      icon: 'home'
    },
    children: [{
      path: 'qrcodeApplyManage',
      name: 'qrcodeApplyManage',
      component: () => import('@/views/qrcode/qrcodeManage/index'),
      meta: {
        title: '码申请列表',
        icon: 'product-list'
      }
    },
      {
        path: 'scanaudding',
        name: 'scanaudding',
        component: () => import('@/views/qrcode/scanaudding/index'),
        meta: {
          title: '扫码窜货查询',
          icon: 'product-list'
        }
      },
      {
        path: 'qrcodeApplyDetail',
        name: 'qrcodeApplyDetail',
        component: () => import('@/views/qrcode/qrcodeManage/detail'),
        meta: {
          title: '码申请详情'
        },
        hidden: true
      },
      {
        path: 'addQrcodeApply',
        name: 'addQrcodeApply',
        component: () => import('@/views/qrcode/qrcodeManage/add'),
        meta: {
          title: '添加码申请'
        },
        hidden: true
      },
      {
        path: 'updateQrcodeApply',
        name: 'updateQrcodeApply',
        component: () => import('@/views/qrcode/qrcodeManage/update'),
        meta: {
          title: '编辑码申请'
        },
        hidden: true
      },
      {
        path: 'deleteQrcodeApply',
        name: 'deleteQrcodeApply',
        component: () => import('@/views/cms/subject/update'),
        meta: {
          title: '删除码申请'
        },
        hidden: true
      },
      {
        path: 'qrcodeApplyCheck',
        name: 'qrcodeApplyCheck',
        component: () => import('@/views/qrcode/qrcodeManage/index'),
        meta: {
          title: '码申请管理',
          icon: 'product-list'
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userManage',
    name: 'user',
    meta: {
      title: '员工管理',
      icon: 'home'
    },
    children: [{
      path: 'userManage',
      name: 'userManage',
      component: () => import('@/views/user/userManage/index'),
      meta: {
        title: '员工列表',
        icon: 'product-list'
      }
    },
      {
        path: 'userDetail',
        name: 'userDetail',
        component: () => import('@/views/user/userManage/detail'),
        meta: {
          title: '员工详情'
        },
        hidden: true
      },
      {
        path: 'addUser',
        name: 'addUser',
        component: () => import('@/views/user/userManage/add'),
        meta: {
          title: '添加员工'
        },
        hidden: true
      },
      {
        path: 'updateUser',
        name: 'updateUser',
        component: () => import('@/views/user/userManage/update'),
        meta: {
          title: '编辑员工'
        },
        hidden: true
      },
      {
        path: 'deleteUser',
        name: 'deleteUser',
        component: () => import('@/views/cms/helpCategory/index'),
        meta: {
          title: '删除员工'
        },
        hidden: true
      }, {
        path: 'updateRole',
        name: 'updateRole',
        component: () => import('@/views/cms/helpCategory/add'),
        meta: {
          title: '编辑角色'
        },
        hidden: true
      }
    ]
  },

  {
    path: '/report',
    component: Layout,
    redirect: '/report/deliveryItemReportList',
    name: 'report',
    meta: {
      title: '报表管理',
      icon: 'report'
    },
    children: [{
      path: 'deliveryItemReportList',
      name: 'deliveryItemReportList',
      component: () => import('@/views/report/delivery/deliveryItemReport/index'),
      meta: {
        title: '发货单详情报表',
        icon: 'report-list'
      }
    },
      // {
      //   path: 'deliveryItemReportDetail',
      //   name: 'deliveryItemReportDetail',
      //   component: () => import('@/views/user/userManage/detail'),
      //   meta: {
      //     title: '员工详情'
      //   },
      //   hidden: true
      // },
    ]
  },

  {
    path: '/system',
    component: Layout,
    redirect: '/system/roleManage',
    name: 'role',
    meta: {
      title: '角色管理',
      icon: 'home'
    },
    children: [{
      path: 'roleManage',
      name: 'roleManage',
      component: () => import('@/views/sys/role/index'),
      meta: {
        title: '角色列表',
        icon: 'product-list'
      }
    },
      {
        path: 'roleDetail',
        name: 'roleDetail',
        component: () => import('@/views/sys/role/detail'),
        meta: {
          title: '角色详情'
        },
        hidden: true
      },
      {
        path: 'addRole',
        name: 'addRole',
        component: () => import('@/views/sys/role/add'),
        meta: {
          title: '添加角色'
        },
        hidden: true
      },
      // {
      //   path: 'updateRole',
      //   name: 'updateRole',
      //   component: () => import('@/views/sys/role/update'),
      //   meta: {
      //     title: '编辑角色'
      //   },
      //   hidden: true
      // },
      {
        path: 'deleteRole',
        name: 'deleteRole',
        component: () => import('@/views/cms/helpCategory/index'),
        meta: {
          title: '删除角色'
        },
        hidden: true
      }
    ]
  },


  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]


export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js